import { useTranslation } from "react-i18next"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { Globe } from "lucide-react"
import { Button } from "../ui/button"
import { cn } from "@/lib/utils"

const LanguageSwitcher = ({
  dropdownClassName,
}: {
  dropdownClassName?: string
}) => {
  const { i18n } = useTranslation()

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng)
  }

  return (
    <div className="flex items-center gap-2">
      <div className="language-switcher">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button className="language-dropdown-trigger cursor-pointer">
              {/* <Globe className="mr-1 h-4 w-4" /> */}
              <span className=" ">
                {i18n.language === "en"
                  ? "EN"
                  : i18n.language === "ua"
                    ? "UA"
                    : i18n.language === "de"
                      ? "DE"
                      : i18n.language === "fr"
                        ? "FR"
                        : i18n.language === "it"
                          ? "IT"
                          : i18n.language === "es"
                            ? "ES"
                            : "PL"}
              </span>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            align="end"
            className={cn("language-dropdown-content", dropdownClassName)}
          >
            <DropdownMenuItem
              className={`language-dropdown-item cursor-pointer ${i18n.language === "en" ? "active" : ""} `}
              onClick={() => changeLanguage("en")}
            >
              <span className=" ">English</span>
            </DropdownMenuItem>
            <DropdownMenuItem
              className={`language-dropdown-item cursor-pointer ${i18n.language === "ua" ? "active" : ""} `}
              onClick={() => changeLanguage("ua")}
            >
              <span className=" ">Українська</span>
            </DropdownMenuItem>
            {/* <DropdownMenuItem
              className={`language-dropdown-item ${i18n.language === "de" ? "active" : ""}  `}
              onClick={() => changeLanguage("de")}
            >
              <span className=" ">Deutsch</span>
            </DropdownMenuItem>
            <DropdownMenuItem
              className={`language-dropdown-item ${i18n.language === "fr" ? "active" : ""}  `}
              onClick={() => changeLanguage("fr")}
            >
              <span className=" ">Français</span>
            </DropdownMenuItem>
            <DropdownMenuItem
              className={`language-dropdown-item ${i18n.language === "it" ? "active" : ""}  `}
              onClick={() => changeLanguage("it")}
            >
              <span className=" ">Italiano</span>
            </DropdownMenuItem>
            <DropdownMenuItem
              className={`language-dropdown-item ${i18n.language === "es" ? "active" : ""}  `}
              onClick={() => changeLanguage("es")}
            >
              <span className=" ">Español</span>
            </DropdownMenuItem>
            <DropdownMenuItem
              className={`language-dropdown-item ${i18n.language === "pl" ? "active" : ""}  `}
              onClick={() => changeLanguage("pl")}
            >
              <span className=" ">Polski</span>
            </DropdownMenuItem> */}
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </div>
  )
}

export default LanguageSwitcher
